export enum FlatRoomTypeEnum {
  room1 = '01',
  room2 = '02',
  room3 = '03',
  room4 = '04',
  room5 = '05',
  executive = '06',
  hudc = '07',
  multi_generation = '08',
}
